import React from 'react';
import { network } from '@tencent/netcheck';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import NormalAttachmentToolbar from '../normal';
import { AUDIO_QUICK_BAR_CONTAINER } from '@src/framework/editor/src/page/index/components/canvas/element-types/image-element/media-container/media-element-presenter';
import styles from './index.less';
import { PPTEditorStateTypeValue } from '@src/slide/domain/ui-model/constant/edit-state-type';

interface AudioToolBarProps {
    selectedModel: IPictureModel;
    pptEditorState: PPTEditorStateTypeValue;
}
export default function AudioToolBar(props: AudioToolBarProps) {
    const { selectedModel, pptEditorState } = props;
    return (
        <div className={styles['audio-tool-bar']}>
            <NormalAttachmentToolbar selectedModel={selectedModel} pptEditorState={pptEditorState}/>
            {
                network.isOnline && <>
                    <div className={styles['dividing-line']}/>
                    <div id={AUDIO_QUICK_BAR_CONTAINER} className={styles['player-bar']}/>
                </>
            }
        </div>
    );
}
